import { Constants } from './../../shared/shared-constants';

import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { FileShareDataset } from 'app/model/dataset/file-share.dataset';
import { FileServerLinkedService } from 'app/model/linkedservice/file-server.linkedservice';
import { maxConcurrentConnectionsMetadata, recursiveCheckboxMetadata, copyBehaviorMetadata } from '../consts/metadata-consts';
import { FtpServerLinkedService, HdfsLinkedService, SftpServerLinkedService } from 'shell-models-lib';

export const fileShareDatasetMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(FileShareDataset).name,
    supportLinkedServiceTypes: [
        Metamodel.modelFor(FileServerLinkedService).name,
        Metamodel.modelFor(HdfsLinkedService).name,
        Metamodel.modelFor(FtpServerLinkedService).name,
        Metamodel.modelFor(SftpServerLinkedService).name
    ],
    displayName: stringResources.FileShare_DisplayText,
    datasetKind: 'file',
    isSource: true,
    isSink: true,
    icon: {
        className: 'svg-i-100x100-FileSystem'
    },
    isFirstClass: true,
    category: ['File'],
    supportGetMetadataActivity: true,
    supportRootFolder: true,
    pathRegex: {
        pattern: Constants.fileSharePathValidation,
        message: stringResources.CopyWizard_Dataset_File_Sink_FileSharePathValidationError
    },
    supportDeleteActivity: true,
    copySourceControls: [
        recursiveCheckboxMetadata,
        maxConcurrentConnectionsMetadata
    ],
    copySinkControls: [
        copyBehaviorMetadata,
        maxConcurrentConnectionsMetadata
    ]
};
